import { ecommerceEvent, slugify } from '@grupoboticario/tag-book-sellout'
import { ProductTagService } from '../productTagService'
import {
  ProductItem,
  GoogleAnalyticsService,
  slugfy,
  VWOAnalyticsService,
  VWOEvents,
} from '@grupoboticario/barril-del-chavo'
import { ShopWindowType } from 'src/components/molecules/ShopWindow/types'

function enhanceWithLowStockDimensions(item: ProductItem) {
  try {
    const hasLowStockTag = ProductTagService.hasTagLowStock(item.tags ?? [])

    return {
      ...item,
      category5: hasLowStockTag ? 'poucas-unidades' : undefined,
      status: hasLowStockTag ? 'poucas-unidades' : item.status,
    }
  } catch {
    return item
  }
}

export type ViewListItemEventArgs = {
  listName: string
  products: ProductItem[]
  cycle?: string
}

export function sendViewItemListEvent({ listName, products, cycle }: ViewListItemEventArgs) {
  // Remove emojis da listName antes de enviar para o GA
  const cleanListName = listName
    .replace(/[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu, '')
    .trim()

  ecommerceEvent({
    eventName: 'view_item_list',
    products: products.map(enhanceWithLowStockDimensions),
    parameters: {
      item_list_name: cleanListName,
      item_list_id: slugfy(cleanListName),
      // @ts-ignore para contornar o uso da biblioteca tag-book-sellout que atualmente está deletada
      cd_ciclo: cycle,
    },
  })
}

export interface trackShopWindowEventsArgs {
  cd_interaction_detail: string
  listName: ShopWindowType
  cycle?: string
}

export const trackShopWindowEvents = ({
  cd_interaction_detail,
  listName,
  cycle,
}: trackShopWindowEventsArgs) => {
  const eventData = {
    event: 'analytics-event',
    event_parameters: {
      event_name: 'interaction_vitrines',
      cd_interaction_detail: cd_interaction_detail,
      list_name: slugify(listName),
      cd_ciclo: cycle,
    },
  }

  VWOAnalyticsService.dispatchVWOEvent(VWOEvents.INTERACTION_WITH_SHOP_WINDOW, {
    actiontype: cd_interaction_detail,
    placement: 'home',
    name: eventData.event_parameters.list_name,
  })
  GoogleAnalyticsService.event(eventData)
}
